<template>
    <div id="couponPanel" class="cover">
        <div class="cover_center_panel coupon_cover_panel">
			<div class="coupon-title">夏日狂欢 倾情回馈</div>
			<div class="coupon-image">
				<img class="coupon-bg" src="./img/coupon-ditu.png" />
				<img class="coupon-tag" src="data:image/png;base64,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"/>
				<div class="coupon_text">
					<div class="coupon-lijian">立减</div>
					<div class="coupon-price">￥{{couponMoney}}</div>
					<div class="left_count">剩余：{{left_count}}/200</div>
				</div>
				<div class="coupon-today">限量供应</div>
			</div>
			<div class="left_label">限量200份，先到先得</div>
			<img class="coupon-bottom-bj" src="./img/background-icon.png" />
			<div class="coupon-btn"><button @click="recieveNow" class="btn-ele">立即领取</button></div>
			<div @click="closeCouponPopup" class="close-icon">我不需要，谢谢</div>
        </div>
    </div>
</template>
<script type="text/ecmascript-6">
    export default {
		name:"couponpopup",
		props:['showPopup','couponMoney'],
		data() {
			return {
				left_count:100
			};
		},
		methods:{
			//关闭优惠券弹窗
			closeCouponPopup(){
				this.$emit('update:showPopup',false)
				//埋点
                let user_id = localStorage.getItem("user_id")||0;
                zjzBrowseRecord({user_id:user_id, mod_code:"p006"})
			},
			//立即领取兑换券
			recieveNow(){
				this.$emit('update:showPopup',false)
				this.$emit("receiveHandle")
				//埋点
                let user_id = localStorage.getItem("user_id")||0;
                zjzBrowseRecord({user_id:user_id, mod_code:"p005"})
			}
		}
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .coupon_cover_panel{
        width: 264px;
		height: 321px;
		background: linear-gradient(#ff3846,#fe6f62);
		border-radius: 10px;
		position: relative;
		.coupon-title{
			text-align: center;
			color: #fff;
			font-size: 20px;
			font-weight: bold;
			padding-top: 8px;
			line-height: 55px;
		}
		.coupon-image{
			margin: 0px 27px;
			position: relative;
			.coupon-bg{
				width: 209px;
				height: 109px;
			}
			.coupon-tag{
				position: absolute;
				top: 0;
				right: 12px;
				width: 23px;
				height: 78px;
			}
			.coupon_text{
				position: absolute;
				top: 0;
				left: 24px;
				padding-top: 6px;
				text-align: center;
				color: #ff4945;
				width: 140px;
				.coupon-lijian{
					font-size: 14px;
					line-height: 25px;
				}
				.coupon-price{
					font-size: 32px;
					font-weight: 700;
					line-height: 37px;
				}
				.left_count{
					margin: 5px auto 0;
					width: 98px;
					height: 23px;
					text-align: center;
					color: #fff;
					font-size: 12px;
					line-height: 23px;
					border-radius: 12px;
					background-image: linear-gradient(#eb4c4e,#ed7768);
				}
			}
			.coupon-today{
				position: absolute;
				top: 4px;
				right: 16px;
				color: #995609;
				font-size: 11px;
				writing-mode: vertical-lr;
				letter-spacing: 4px;
			}
		}
		.left_label{
			font-size: 12px;
			text-align: center;
			line-height: 42px;
			color: #fff;
		}
		.coupon-bottom-bj{
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
			height: 122px;
			width: 100%;
			border-radius: 0px 0px 10px 10px;
		}
		.coupon-btn{
			position: absolute;
			bottom: 43px;
			left: 0;
			right: 0;
			margin: 0px 49px;
			.btn-ele{
				background: linear-gradient(1turn,#ffc600,#ffe023 39%,#fff945);
				box-shadow: 0px 4px 0px #ff8516;
				opacity: 1;
				border-radius: 18px;
				height: 36px;
				line-height: 36px;
				color: #b56408;
				font-size: 15px;
                border: none;
                width: 100%;
				animation: scaleDrew 2.4s ease-in-out infinite;
                cursor: pointer;
			}
		}
		.close-icon{
			position: absolute;
			bottom: 14px;
			font-size: 13px;
			line-height: 21x;
			left: 50%;
			cursor: pointer;
			transform: translateX(-50%);
			color: #fff;
		}
    }
	@keyframes scaleDrew {
		0% {
		    transform: scale(1);
		}
		25% {
		    transform: scale(1.1);
		}
		50% {
		    transform: scale(1);
		}
		75% {
		    transform: scale(1.1);
		}
	}
</style>